import axios from "axios";
import config from '../config'

export function getUserLandsByMetaverseName(address, slugId) {
    let url = `${config.URL}/api/lands/get/${address}/${slugId}`;
    return axios.get(url).then((response) => {
        return response.data.data
    });
}
